import { render } from "./IconText.vue?vue&type=template&id=5fca3bd8&scoped=true"
import script from "./IconText.vue?vue&type=script&lang=js"
export * from "./IconText.vue?vue&type=script&lang=js"

import "./IconText.vue?vue&type=style&index=0&id=5fca3bd8&lang=scss&scoped=true"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fca3bd8"]])

export default __exports__